import React, { useEffect, useState } from "react";
import Select from 'react-select';

import "./styles.scss";
import PanelTemplate from "../../templates/Panel";
import BoxMoney from "../../components/dashboard/BoxMoney";
import BoxDoughnutChart from "../../components/dashboard/BoxDoughnutChart";
import BoxCount from "../../components/dashboard/BoxCount";
import { Filter } from "../../components/dashboard/Filter";
import Table from "../../components/Table";
import Box from "../../components/Box";
import BoxVerticalBarChart from "../../components/dashboard/BoxVerticalBarChart";
import Modal from "../../components/Modal";
import api from "../../services/api";
import { convertIntToMoney } from "../../helpers/conversions";
import moment from "moment";
import { toast } from "react-toastify";
import { Loading } from "../../components/Loading";
import { hasPermission } from "../../services/auth";
import InputDate from "../../components/InputDate";
import Button from "../../components/Button";
import InputCheckboxes from "../../components/InputCheckboxes";
import { createOptions } from "../../helpers/selects";

const options = [
    { value: 'approved', label: 'Aprovado' },
    { value: 'wating', label: 'Aguardando' },
    { value: 'pending', label: 'Pendente' }
];

export const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [loadingStatuses, setLoadingStatuses] = useState(true);
    const [loadingRanking, setLoadingRanking] = useState(true);

    const [type, setType] = useState('budget');

    const date = new Date();
    const sDate = new Date(date.getFullYear(), date.getMonth(), 1);
    const fDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const [startDate, setStartDate] = useState(moment(sDate).format('YYYY-MM-DD'));
    const [finalDate, setFinalDate] = useState(moment(fDate).format('YYYY-MM-DD'));

    const [startChartDate, setStartChartDate] = useState(sDate);
    const [finalChartDate, setFinalChartDate] = useState(fDate);
    const [selectedChartStatuses, setSelectedChartStatuses] = useState([]);

    const [amountBudgets, setAmountBudgets] = useState(0);
    const [averageTicket, setAverageTicket] = useState(0);
    const [averageItems, setAverageItems] = useState(0);
    const [totalProposalsToday, setTotalProposalsToday] = useState(0);
    const [averageTimeToday, setAverageTimeToday] = useState(0);
    const [averageTimeMonth, setAverageTimeMonth] = useState(0);

    const [totalByStatus, setTotalByStatus] = useState([]);
    const [totalByAdmin, setTotalByAdmin] = useState([]);
    const [totalByMonth, setTotalByMonth] = useState([]);

    const [adminData, setAdminData] = useState({header: [], rows: []});
    const [items, setItems] = useState([]);
    const [sellersRanking, setSellersRanking] = useState({header: [], rows: []});
    const [budgetsRanking, setBudgetsRanking] = useState({header: [], rows: []});

    const [orderStatuses, setOrderStatuses] = useState([]);
    const [budgetStatuses, setBudgetStatuses] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const [companyRanking, setCompanyRanking] = useState([]);
    const [companyStartDate, setCompanyStartDate] = useState(sDate);
    const [companyEndDate, setCompanyEndDate] = useState(fDate);
    const [loadingCompanyRanking, setLoadingCompanyRanking] = useState(false);
    const [showCompaniesModal, setShowCompaniesModal] = useState(false);
    const [modalCompaniesAdmin, setModalCompaniesAdmin] = useState(null);
    const [modalCompaniesList, setModalCompaniesList] = useState([]);
    const [loadingModalCompanies, setLoadingModalCompanies] = useState(false);

    useEffect(() => {
        getStatuses();
    }, []);

    const getStatuses = () => {
        api.get(`/status`).then(res => {
            setOrderStatuses(res.data.resources.filter(status => status.type === 'order'));
            setBudgetStatuses(res.data.resources.filter(status => status.type === 'budget'));
        });
    }

    useEffect(() => {
        if (type === 'company') {
            getCompanyRanking();
            return;
        }
        if(orderStatuses.length > 0 && budgetStatuses.length > 0){
            handleTypeChange();
        }
    }, [type, orderStatuses, budgetStatuses]);

    const handleTypeChange = () => {
      let toStatuses = [];
      let toSelectedStatuses = [];

      if(type === 'budget'){
        toStatuses = budgetStatuses;
      } else {
        toStatuses = orderStatuses;
      }

      toStatuses.map(status => toSelectedStatuses.push(status.id));
      
      setSelectedChartStatuses(toSelectedStatuses);
      setStatuses(toStatuses);
      getData(true);   
    }

    useEffect(() => {
        getAdminData();
    }, [totalByAdmin]);

    useEffect(() => {
        getSellersRankingData();
    }, [loading]);

    const getData = (typeChange = false) => {
        setLoading(true);

        api.get(`/dashboard`, {
            params: {
                start_date: startDate,
                final_date: finalDate,
                start_chart_date: moment(startChartDate).format('YYYY-MM-DD'),
                final_chart_date: moment(finalChartDate).format('YYYY-MM-DD'),
                chart_statuses: typeChange ? [] : selectedChartStatuses,
                type: type
            }
        }).then(res => {
            const { data } = res;
            console.log('data', data);
            setAmountBudgets(data[type].amount_resources);
            setAverageTicket(data[type].average_ticket);
            setAverageItems(data[type].average_items);

            setTotalByStatus(data[type].resources_by_status);
            setTotalByAdmin(data[type].resources_by_admin);
            setTotalByMonth(data[type].resources_by_month);

            
            setItems(generateData(data[type].items));

            if(type === 'budget'){
                setTotalProposalsToday(data[type].total_proposals_today);
                setAverageTimeToday(data[type].average_time_today);
                setAverageTimeMonth(data[type].average_time_month);
            }

            if(data.sellers_ranking){
                generateSellersRankingData(data.sellers_ranking);
            }

            if(data.budgets_ranking){
                generateBudgetsRankingData(data.budgets_ranking);
            }

            setLoadingRanking(false);
            setLoading(false);
        });
    }

    const generateSellersRankingData = (ranking) => {
        const header = ['Pos.', 'Nome'];
        const canViewOrdersAmount = hasPermission('view_orders_ranking_orders_amount');
        const canViewOrdersQuantity = hasPermission('view_orders_ranking_orders_quantity');
        const canViewBudgetsAmount = hasPermission('view_orders_ranking_budgets_amount');
        const canViewBudgetsQuantity = hasPermission('view_orders_ranking_budgets_quantity');
        const canViewConversionRate = hasPermission('view_orders_ranking_conversion_rate');
        const canViewGoalPercentage = hasPermission('view_orders_ranking_goal_percentage');

        if (canViewOrdersAmount) {
            header.push('Total Pedidos');
        }
        if (canViewOrdersQuantity) {
            header.push('Qtd. Pedidos');
        }
        if (canViewBudgetsAmount) {
            header.push('Total Orçamentos');
        }
        if (canViewBudgetsQuantity) {
            header.push('Qtd. Orçamentos');
        }
        if (canViewConversionRate) {
            header.push('Conversão');
        }
        if (canViewGoalPercentage) {
            header.push('Meta do mês');
        }

        const rows = ranking.map((seller, index) => {
            const position = index + 1;
            let positionBadge;
            
            if (position === 1) {
                positionBadge = <span className="ranking-badge ranking-badge-gold">{position}</span>;
            } else if (position === 2) {
                positionBadge = <span className="ranking-badge ranking-badge-silver">{position}</span>;
            } else if (position === 3) {
                positionBadge = <span className="ranking-badge ranking-badge-bronze">{position}</span>;
            } else {
                positionBadge = <span className="ranking-badge">{position}</span>;
            }

            const data = [positionBadge, seller.admin.name];

            if (canViewOrdersAmount) {
                data.push(`R$ ${convertIntToMoney(seller.amount_orders || 0)}`);
            }

            if (canViewOrdersQuantity) {
                data.push(seller.total_orders || 0);
            }

            if (canViewBudgetsAmount) {
                data.push(`R$ ${convertIntToMoney(seller.amount_budgets || 0)}`);
            }

            if (canViewBudgetsQuantity) {
                data.push(seller.total_budgets || 0);
            }

            if (canViewConversionRate) {
                data.push(`${seller.conversion_rate || 0}%`);
            }

            if (canViewGoalPercentage) {
                const goalPercentage = seller.goal_percentage || 0;
                const displayPercentage = Math.min(goalPercentage, 100);
                const progressBarColor = goalPercentage >= 100 ? '#28a745' : goalPercentage >= 75 ? '#ffc107' : '#dc3545';
                const progressBar = (
                    <div className="goal-progress-container">
                        <div className="goal-progress-bar" style={{ width: `${displayPercentage}%`, backgroundColor: progressBarColor }}>
                            <span className="goal-progress-text">{displayPercentage.toFixed(1)}%</span>
                        </div>
                    </div>
                );
                data.push(progressBar);
            }

            return { data };
        });

        setSellersRanking({ header, rows });
    }

    const generateBudgetsRankingData = (ranking) => {
        const header = [
            'Pos.',
            'Nome',
            'Total de orçamentos (R$)',
            'Núm. de orçamentos'
        ];

        const rows = ranking.map((seller, index) => {
            const position = index + 1;
            let positionBadge;
            
            if (position === 1) {
                positionBadge = <span className="ranking-badge ranking-badge-gold">{position}</span>;
            } else if (position === 2) {
                positionBadge = <span className="ranking-badge ranking-badge-silver">{position}</span>;
            } else if (position === 3) {
                positionBadge = <span className="ranking-badge ranking-badge-bronze">{position}</span>;
            } else {
                positionBadge = <span className="ranking-badge">{position}</span>;
            }

            return {
                data: [
                    positionBadge,
                    seller.admin.name,
                    `R$ ${convertIntToMoney(seller.amount_budgets)}`,
                    seller.total_budgets
                ]
            };
        });

        setBudgetsRanking({ header, rows });
    }

    const getSellersRankingData = () => {
        // Este método está sendo chamado pelo useEffect após o loading
    }

    const generateData = items => {
        let rows = [];
        items.map(item => rows.push({ data: [`${item.sku} - ${item.name}`, item.count] }));
        return rows;
    }

    const getCompanyRanking = () => {
        setLoadingCompanyRanking(true);
        api.get(`/dashboard/company-ranking`, {
            params: { start_date: moment(companyStartDate).format('YYYY-MM-DD'), end_date: moment(companyEndDate).format('YYYY-MM-DD') }
        }).then(res => {
            setCompanyRanking(res.data || []);
            setLoadingCompanyRanking(false);
        }).catch(() => setLoadingCompanyRanking(false));
    }

    const openCompaniesModal = (adminId, adminName) => {
        setModalCompaniesAdmin({ id: adminId, name: adminName });
        setShowCompaniesModal(true);
        setLoadingModalCompanies(true);
        api.get(`/dashboard/company-ranking/${adminId}/companies`, {
            params: { start_date: moment(companyStartDate).format('YYYY-MM-DD'), end_date: moment(companyEndDate).format('YYYY-MM-DD') }
        }).then(res => {
            setModalCompaniesList(res.data || []);
            setLoadingModalCompanies(false);
        }).catch(() => setLoadingModalCompanies(false));
    }

    const getAdminData = () => {
        let header = ['Nome do vendedor', `Num. de ${type === 'budget' ? 'orçamentos' : 'pedidos'}`, 'Total'];
        if(type === 'order' && hasPermission('view_margem_order')){
            header.push('Margem real');
        }
        const rows = [];
        
        totalByAdmin.map(admin => {
            let data = [
                admin.admin.name,
                admin.total_resources,
                `R$ ${convertIntToMoney(admin.amount_resources)}`
            ];
            if(type === 'order' && hasPermission('view_margem_order')){
                data.push(`R$ ${convertIntToMoney(admin.amount_margem_real)}`);
            }
            rows.push({
                data,
                to: `/${type === 'budget' ? 'quote' : 'order'}/list`
            })
        });

        setAdminData({header, rows});
    }

    const getCurrentMonthName = () => {
        const monthNames = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        return `${monthNames[currentMonth]} de ${currentYear}`;
    }

    const RankingSkeleton = () => (
        <div className="ranking-skeleton">
            {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="ranking-skeleton-row">
                    <div className="skeleton-badge"></div>
                    <div className="skeleton-name"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-progress"></div>
                </div>
            ))}
        </div>
    );

    const BudgetRankingSkeleton = () => (
        <div className="ranking-skeleton">
            {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="ranking-skeleton-row">
                    <div className="skeleton-badge"></div>
                    <div className="skeleton-name"></div>
                    <div className="skeleton-value"></div>
                    <div className="skeleton-value"></div>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <PanelTemplate id="dashboard">
                <ul className="filter-tab">
                    <li><a href="#" className={type === 'budget' ? 'active' : ''} onClick={e => {
                        e.preventDefault();
                        setType('budget');
                    }}>Orçamentos</a></li>
                    <li><a href="#" className={type === 'order' ? 'active' : ''} onClick={e => {
                        e.preventDefault();
                        setType('order');
                    }}>Pedidos</a></li>
                    {hasPermission('view_new_companies_ranking') && (
                        <li><a href="#" className={type === 'company' ? 'active' : ''} onClick={e => {
                            e.preventDefault();
                            setType('company');
                        }}>Empresas</a></li>
                    )}
                </ul>
                {type === 'company' && (
                    <>
                        <div className="row">
                            <div className="col-6">
                                <Box>
                                    <div className="row">
                                        <div className="col-6">
                                            <InputDate label="Data inicial" change={setCompanyStartDate} value={companyStartDate} />
                                            <InputDate label="Data final" change={setCompanyEndDate} value={companyEndDate} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <Button text="Atualizar" loading={loadingCompanyRanking} action={getCompanyRanking} />
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                        <div className="row ranking-row">
                            <div className="col">
                                <Box className="no-padding" title="Ranking de novas empresas no período">
                                    <Table
                                        loading={loadingCompanyRanking}
                                        header={['Pos.', 'Nome do usuário', 'Qtd. novas empresas', '']}
                                        rows={companyRanking.map((item, index) => {
                                            const position = index + 1;
                                            const positionBadge = position <= 3
                                                ? <span className={`ranking-badge ranking-badge-${['gold', 'silver', 'bronze'][position - 1]}`}>{position}</span>
                                                : <span className="ranking-badge">{position}</span>;
                                            return {
                                                data: [
                                                    positionBadge,
                                                    item.admin.name,
                                                    item.new_companies_count,
                                                    <span key="btn" onClick={e => e.stopPropagation()}>
                                                        <Button
                                                            type="secondary"
                                                            size="small"
                                                            text="Ver novas empresas"
                                                            action={() => openCompaniesModal(item.admin.id, item.admin.name)}
                                                        />
                                                    </span>
                                                ]
                                            };
                                        })}
                                    />
                                </Box>
                            </div>
                        </div>
                        {showCompaniesModal && (
                            <Modal
                                title={`Novas empresas - ${modalCompaniesAdmin?.name || ''}`}
                                show={showCompaniesModal}
                                close={() => { setShowCompaniesModal(false); setModalCompaniesAdmin(null); setModalCompaniesList([]); }}
                                size="large"
                            >
                                {loadingModalCompanies ? (
                                    <Loading />
                                ) : modalCompaniesList.length === 0 ? (
                                    <p>Nenhuma empresa encontrada.</p>
                                ) : (
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Empresa</th>
                                                <th>Data do cadastro</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modalCompaniesList.map((company) => (
                                                <tr key={company.id}>
                                                    <td>{company.trade_name || company.company_name || '-'}</td>
                                                    <td>{company.created_at ? moment(company.created_at).format('DD/MM/YYYY HH:mm') : '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </Modal>
                        )}
                    </>
                )}
                {type !== 'company' && (
                <>
                <div className="row">
                    <div className="col-6">
                        <Box>
                            <div className="row">
                                <div className="col-6">
                                    <InputDate label={`Data inicial`} change={setStartChartDate} value={startChartDate} />
                                    <InputDate label={`Data final`} change={setFinalChartDate} value={finalChartDate} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <InputCheckboxes hideBorder={true} options={createOptions(statuses, 'name', 'id')} selecteds={selectedChartStatuses} setSelecteds={setSelectedChartStatuses} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <Button text={`Atualizar dashboard`} loading={loading} action={getData} />
                                </div>
                            </div>
                        </Box>
                    </div>
                    <div className="col-6">
                        {statuses.length > 0 &&
                            <BoxDoughnutChart 
                                type={type}
                                loading={loading}
                                getData={getData}
                                totalByStatus={totalByStatus}
                                startChartDate={startChartDate}
                                setStartChartDate={setStartChartDate}
                                finalChartDate={finalChartDate}
                                setFinalChartDate={setFinalChartDate}
                                selectedChartStatuses={selectedChartStatuses}
                                setSelectedChartStatuses={setSelectedChartStatuses}
                                statuses={statuses}
                            />
                        }
                    </div>
                </div>
                {type === 'budget' && (loadingRanking || budgetsRanking.rows.length > 0) && (
                    <div className="row ranking-row">
                        <div className="col">
                            <Box 
                                className={`no-padding`}
                                title={`🏆 Ranking de orçamentos - ${getCurrentMonthName()}`}
                            >
                                {loadingRanking ? (
                                    <BudgetRankingSkeleton />
                                ) : (
                                    <Table header={budgetsRanking.header} rows={budgetsRanking.rows} />
                                )}
                            </Box>
                        </div>
                    </div>
                )}
                {type === 'order' && (loadingRanking || sellersRanking.rows.length > 0) && (
                    <div className="row ranking-row">
                        <div className="col">
                            <Box 
                                className={`no-padding`}
                                title={`🏆 Ranking de vendedores - ${getCurrentMonthName()}`}
                            >
                                {loadingRanking ? (
                                    <RankingSkeleton />
                                ) : (
                                    <Table header={sellersRanking.header} rows={sellersRanking.rows} />
                                )}
                            </Box>
                        </div>
                    </div>
                )}
                {!loading && type === 'budget' && (
                    <div className="row">
                        <div className="col-4">
                            <BoxCount
                                text={<>Orçamentos enviados hoje<br />sem filtro de status</>}
                                value={totalProposalsToday}
                            />
                        </div>
                        <div className="col-4">
                            <BoxCount
                                text={<>Tempo médio de resposta hoje<br />sem filtro de status</>}
                                value={`${averageTimeToday} min.`}
                            />
                        </div>
                        <div className="col-4">
                            <BoxCount
                                text={<>Tempo médio de resposta no período<br />sem filtro de status</>}
                                value={`${averageTimeMonth} min.`}
                            />
                        </div>
                    </div>
                )}
                {!loading && type === 'budget' && (
                    <div className="row">
                        <div className="col-4">
                            <BoxMoney
                                text={`${type === 'budget' ? 'Orçamentos' : 'Pedidos'} realizados no período`}
                                value={amountBudgets}
                            />
                        </div>
                        <div className="col-4">
                            <BoxMoney
                                text={`Ticket médio dos ${type === 'budget' ? 'orçamentos' : 'pedidos'} do período`}
                                value={averageTicket}
                            />
                        </div>
                        <div className="col-4">
                            <BoxCount
                                text={`Número médio de itens nos ${type === 'budget' ? 'orçamentos' : 'pedidos'}`}
                                value={averageItems}
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col">
                        <Box 
                            className={`no-padding`}
                            title={`Produtos mais ${type === 'budget' ? 'orçados' : 'pedidos'} no período`}
                            // tools={<Select options={options} />}
                        >
                            <Table loading={loading} header={['Produto', `Quant. de ${type === 'budget' ? 'orçamentos' : 'pedidos'}`]} rows={items} />
                        </Box>
                    </div>
                    <div className="col">
                        <Box 
                            className={`no-padding`}
                            title={`Desempenho dos vendedores no período`}
                            // tools={<Select options={options} />}
                        >
                            <Table loading={loading} header={adminData.header} rows={adminData.rows} />
                        </Box>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <BoxVerticalBarChart totalByMonth={totalByMonth} title={`${type === 'budget' ? 'Orçamentos' : 'Pedidos'} nos últimos meses`}  />
                    </div>
                </div>
                </>
                )}
            </PanelTemplate>
        </>
    );
}

export default Dashboard;